import { Icons, Tooltip, LoadingAnimation } from "@texada/ui";
import * as React from "react";
import "./SimpleTooltip.scss";

const Container = ({ children, style = {} }) => {
  return (
    <div className="tui-simple-tooltip--items" style={style}>
      {children}
    </div>
  );
};

const Bold = ({ children, style = {} }) => {
  return (
    <div className="tui-simple-tooltip--items--bold" style={style}>
      {children}
    </div>
  );
};

const Content = ({ children, style = {} }) => {
  return (
    <div className="tui-simple-tooltip--items--content" style={style}>
      {children}
    </div>
  );
};

const Grey = ({ children, style = {} }) => {
  return (
    <div className="tui-simple-tooltip--items--grey" style={style}>
      {children}
    </div>
  );
};

interface ISimpleTooltip<T> {
  item: T;
  style?: React.CSSProperties;
  debug?: boolean;
  render: ({
    item,
    Container
  }: {
    item: T;
    Container: React.FC;
    Bold: React.FC;
    Content: React.FC;
    Grey: React.FC;
  }) => React.ReactNode | React.ReactNode[];
  children?: React.ReactNode;
  onHover: () => void;
}

const SimpleTooltip = <T,>({
  item,
  style = {},
  debug,
  render,
  children,
  onHover
}: ISimpleTooltip<T>) => {
  const [isHover, setIsHover] = React.useState<boolean>(false);

  const onMouseEnter = () => {
    setIsHover(true);
    onHover()
  }
  const onMouseLeave = () => setIsHover(false);

  return (
    <>
      <div
        style={style}
        className={"tui-simple-tooltip-container"}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children ? children : <Icons.Info />}
        {isHover & !item ? (
          <Tooltip
            debug={true}
            className="tui-document-viewer-tooltip"
            label={
              <div style={{
                  width: 390,
                  minHeight: 200,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                  <LoadingAnimation />
              </div>
            }
            defaultPosition="right"
            variant="light"
          >
            <div />
          </Tooltip>
        ) : (
          <></>
        )}
        {isHover && item ? (
          <Tooltip
            debug={debug}
            className="tui-simple-tooltip"
            label={render({ item, Container, Bold, Content, Grey })}
            defaultPosition="right"
            variant="light"
          >
            <div />
          </Tooltip>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default SimpleTooltip;
